module.exports = {
      id: "arcade-usage",
      viewBox: "0 0 19.915 20.731",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#arcade",
      toString: function () {
        return this.url;
      }
    }